import { render, staticRenderFns } from "./statisticsSearch.vue?vue&type=template&id=1281d7db&scoped=true&"
import script from "./statisticsSearch.vue?vue&type=script&lang=js&"
export * from "./statisticsSearch.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSearch.vue?vue&type=style&index=0&id=1281d7db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281d7db",
  null
  
)

export default component.exports